"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILDatePicker = void 0;
var react_1 = __importDefault(require("react"));
var AdapterDateFns_1 = require("@mui/x-date-pickers/AdapterDateFns");
var date_localization_provider_1 = __importDefault(require("../../providers/date-localization.provider"));
var DatePicker_1 = require("@mui/x-date-pickers/DatePicker");
var week_picker_1 = require("./week-picker");
var centerButtonSx = {
    '& .PrivatePickersYear-yearButton': {
        textAlign: 'center',
    },
};
var ILDatePicker = function (_a) {
    var useWeekSelector = _a.useWeekSelector, className = _a.className, props = __rest(_a, ["useWeekSelector", "className"]);
    return (react_1.default.createElement(date_localization_provider_1.default, { dateAdapter: AdapterDateFns_1.AdapterDateFns },
        react_1.default.createElement(DatePicker_1.DatePicker, __assign({ 
            // defaults
            className: 'il-date-picker ' + className,
            label: 'Date',
            disabled: false }, (useWeekSelector && {
            renderDay: (0, week_picker_1.customWeekPicker)(props.value),
            PopperProps: {
                sx: {
                    '& .MuiDayPicker-weekContainer:hover': {
                        '&> button': {
                            backgroundColor: 'action.disabledBackground',
                            borderRadius: 0,
                            '&:first-of-type': {
                                borderTopLeftRadius: '50%',
                                borderBottomLeftRadius: '50%',
                            },
                            '&:last-child': {
                                borderTopRightRadius: '50%',
                                borderBottomRightRadius: '50%',
                            },
                        },
                        '&> .MuiButtonBase-root:hover': {
                            backgroundColor: 'action.disabled',
                        },
                    },
                },
            },
        }), { DialogProps: {
                sx: centerButtonSx,
            },
            PaperProps: {
                sx: centerButtonSx,
            } }, props))));
};
exports.ILDatePicker = ILDatePicker;
